import pad from 'pad';

const customStyles = {
  rows: {
    style: {
      minHeight: '72px', // override the row height
    }
  },
  headCells: {
    style: {
      paddingLeft: '8px', // override the cell padding for head cells
      paddingRight: '8px',
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
    },
  },
};

const columnSucursales = [
   {
      name: 'Codigo',
      selector: 'id',
      sortable: true,
      grow: 0,
      cell: row => (
        pad(5,row.id,'0')
      )
    },
    {
      name: 'Sucursal',
      selector: 'description',
      sortable: true,
    },
  ];

  const columnSucursalesOption = (selection, optionselect) => { 
    return [
        {
          name: 'Codigo',
          selector: 'id',
          sortable: true,
          grow: 0,
          cell: row => (
            pad(5,row.id,'0')
          )
        },
        {
          name: 'Sucursal',
          selector: 'description',
          sortable: true,
        },
    ]
  }
 

const table = {
  columnSucursales,
  customStyles,
  columnSucursalesOption,
}

export default table;